const sortRowNumber = (a, b) => {
  if (a.rowNumber < b.rowNumber) return -1;
  else if (a.rowNumber > b.rowNumber) return 1;
  else return 0;
};
export default sortRowNumber;
